'use client';

import classNames from 'classnames';
import { Product } from 'shared/types/product';
import Image, { ImageProps } from 'components/gruenland/atoms/image';
import { TYPOGRAPHY_MODULE_TITLE } from 'lib/typography';
import { useWishlist } from 'frontastic';
import ProductSliderFullwidth from '../product-slider-fullwidth/ProductSliderFullwidth';

export type Module07Props = {
  title?: string;
  layoutVariant: 'dx' | 'sx';
  image?: ImageProps;
  imageLg?: ImageProps;
  products: Product[];
};

export const Module07 = ({ title, layoutVariant = 'dx', image, imageLg, products }: Module07Props) => {
  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();
  return (
    <div className="lg:container">
      <div className="flex flex-col gap-10 md:p-[60px]">
        <h2 className={classNames(TYPOGRAPHY_MODULE_TITLE, 'text-center lg:text-left')}>{title}</h2>
        <div className="grid gap-10 lg:grid-cols-2">
          {image && (
            <div
              className={classNames('relative aspect-square h-auto max-w-full', {
                'lg:hidden': imageLg?.media,
              })}
            >
              <Image {...image} alt={image.alt} className="object-cover" fill />
            </div>
          )}
          {imageLg?.media && (
            <div className="relative hidden aspect-square h-auto max-w-full lg:block">
              <Image {...imageLg} alt={imageLg.alt} className="object-cover" fill />
            </div>
          )}
          <div
            className={classNames('w-full overflow-hidden', {
              'lg:order-first': layoutVariant === 'sx',
            })}
          >
            <ProductSliderFullwidth
              wishlist={wishlist}
              products={products}
              addToWishlist={async (lineItem, count) => {
                if (wishlist) await addToWishlist(wishlist, lineItem, count);
              }}
              removeLineItem={async (lineItem) => {
                if (wishlist) await removeLineItem(wishlist, lineItem);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
